module.exports = __webpack_public_path__ + "img/logo.8bfe6faf.svg";